import styled from 'styled-components';

export interface ButtonProps {
    color: string | undefined,
    backgroundColor: string | undefined,
    border?: string,
    borderColor?: string,
    fontWeight?: number,
    opacityOnDisabled?: boolean
    gap?: string;
    minWidth?: string;
}

export const ButtonType = styled('button')<ButtonProps>`
    color: ${(props)=> props.color};
    background-color: ${props => props.backgroundColor};
    border-width: ${props => props.border ? props.border : "0px"};
    border-color: ${props => props.borderColor};
    border-style: solid;
    font-size: 18px;
    font-weight: ${props => props.fontWeight};
    opacity: ${props => props.opacityOnDisabled ? '0.5' : '1'};
    width: 100%;
    min-width: ${props => props.minWidth};
    border-radius: 24px;
    min-height: 50px;
    margin: 10px 0;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: ${props => props.gap ? props.gap : "15px"};
    cursor: pointer;
    @media (max-width: 600px) {
        gap: 10px;
    }
`;
interface ButtonsWrapperProps {
    wrapperPadding?: string;
    show?: boolean;
  }
  
export const ButtonsWrapper = styled.div<ButtonsWrapperProps>`
    width: 100%;
    max-width: 350px;
    padding: ${props => props.wrapperPadding};
    @media (max-width: 850px) {
       width: 100%;
       max-width: none;
       padding: 10px;
    }
`;

export const PayButtonWrapper = styled(ButtonsWrapper)`
    width: ${props => props.show ? '50%' : '0'};
    @media (max-width: 650px) {
       width: ${props => props.show ? '100%' : '0'};
       display: ${props => props.show ? 'block' : 'none'};
       padding: 10px 0px;
    }
`
  